

// Função para agrupar os itens por "bundle_group" e mover para o <div class="itens-kit">
function organizeCartItemsByBundleGroup() {
  // Seleciona o formulário que contém os itens do carrinho
  const formCartItems = document.querySelector('form.cart-drawer__items');
  if (!formCartItems) {
    console.log('Formulário de itens do carrinho não encontrado.');
    return;
  } else {
    console.log('Formulário de itens do carrinho encontrado.');
  }

  // Obtém todos os elementos <cart-item> dentro do formulário que ainda não foram processados
  const cartItems = Array.from(
    formCartItems.querySelectorAll('cart-item.cart-item:not([data-processed])')
  );
  console.log('Número de novos itens do carrinho para processar:', cartItems.length);

  // Objeto para armazenar os grupos de itens baseados em "bundle_group"
  const bundleGroups = {};

  // Agrupa os itens pelo valor de "bundle_group"
  cartItems.forEach(cartItem => {
    const bundleGroup = getBundleGroup(cartItem);
    console.log('Verificando bundle_group no item:', bundleGroup);

    if (bundleGroup) {
      if (!bundleGroups[bundleGroup]) {
        bundleGroups[bundleGroup] = [];
      }
      bundleGroups[bundleGroup].push(cartItem);
    }
  });

  // Cria um <div class="itens-kit"> para cada grupo de "bundle_group" se ainda não existir
  Object.keys(bundleGroups).forEach(bundleGroup => {
    const itemsInGroup = bundleGroups[bundleGroup];
    console.log(`Preparando <div class="itens-kit"> para o grupo: ${bundleGroup} com ${itemsInGroup.length} itens.`);

    // Verifica se já existe um <div class="itens-kit"> para esse grupo
    let itensKitDiv = formCartItems.querySelector(`.itens-kit[data-bundle-group="${bundleGroup}"]`);

    if (!itensKitDiv) {
      // Cria o contêiner para o grupo se não existir
      itensKitDiv = document.createElement('div');
      itensKitDiv.classList.add('itens-kit');
      itensKitDiv.setAttribute('data-bundle-group', bundleGroup);

      // Adiciona o <div class="itens-kit"> ao formulário
      formCartItems.appendChild(itensKitDiv);
      console.log(`<div class="itens-kit"> criado para o grupo ${bundleGroup} e adicionado ao formulário.`);
    }

    // Verifica se o cabeçalho "Produtos do Kit" já existe dentro do div
    let kitHeader = itensKitDiv.querySelector('.cart-items__params-item');
    if (!kitHeader) {
      kitHeader = document.createElement('div');
      kitHeader.classList.add('cart-items__params-item');
      kitHeader.textContent = 'Produtos do Kit';
      itensKitDiv.prepend(kitHeader); // Adiciona o cabeçalho ao início do contêiner
      console.log(`Cabeçalho "Produtos do Kit" adicionado ao grupo ${bundleGroup}.`);
    }

    // Move cada item do grupo para dentro do <div class="itens-kit">
    itemsInGroup.forEach(item => {
      itensKitDiv.appendChild(item);
      item.setAttribute('data-processed', 'true'); // Marca o item como processado
    });
  });
}


  // Função auxiliar para encontrar o valor de bundle_group dentro de um cart-item
  function getBundleGroup(cartItem) {
    const options = cartItem.querySelectorAll('.cart-item__option');
    for (let option of options) {
      const label = option.querySelector('div:first-child');
      const value = option.querySelector('div:last-child');
      if (label && label.textContent.trim() === 'bundle_group:') {
        console.log('bundle_group encontrado:', value.textContent.trim());
        return value.textContent.trim();
      }
    }
    console.log('bundle_group não encontrado no item.');
    return null;
  }

  // Chama a função para organizar os itens quando a página é carregada
  organizeCartItemsByBundleGroup();








// Função para validar e remover itens com bundle_group se a quantidade total não corresponder a qtdKit
function validateAndRemoveItemsByBundleGroup() {
  // Obtém os itens do carrinho
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Cria um objeto para agrupar itens por bundle_group e verificar qtdKit
      const bundleGroups = {};

      // Percorre cada item do carrinho para organizar e verificar os grupos
      cart.items.forEach(item => {
        if (item.properties && item.properties.bundle_group && item.properties.qtdKit) {
          const bundleGroup = item.properties.bundle_group;
          const qtdKit = parseInt(item.properties.qtdKit, 10);

          // Inicializa o grupo se ele ainda não existe
          if (!bundleGroups[bundleGroup]) {
            bundleGroups[bundleGroup] = { items: [], qtdKit, totalQuantity: 0 };
          }

          // Adiciona o item ao grupo e soma a quantidade
          bundleGroups[bundleGroup].items.push(item);
          bundleGroups[bundleGroup].totalQuantity += item.quantity;
        }
      });

      // Verifica cada grupo para ver se a quantidade total de itens está correta
      Object.keys(bundleGroups).forEach(bundleGroup => {
        const { items, qtdKit, totalQuantity } = bundleGroups[bundleGroup];

        console.log(`Verificando bundle_group: ${bundleGroup} - Necessário: ${qtdKit}, Encontrado: ${totalQuantity}`);

        // Se a quantidade total não corresponder ao qtdKit, remove todos os itens do grupo
        if (totalQuantity !== qtdKit) {
          console.log(`Quantidade incorreta de itens para ${bundleGroup}. Removendo todos os itens do grupo.`);
          removeItemsWithBundleGroup(bundleGroup);
        }
      });
    })
    .catch(error => console.error('Erro ao validar itens por bundle_group:', error));
}

// Função para remover todos os itens com o mesmo "bundle_group"
function removeItemsWithBundleGroup(bundleGroup) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const bundleItems = cart.items.filter(item => item.properties && item.properties.bundle_group === bundleGroup);
      console.log('Itens encontrados com o bundle_group:', bundleItems); // Log dos itens encontrados

      // Variável para rastrear quantos itens precisam ser removidos
      let itemsToRemove = bundleItems.length;
      let removedItems = 0;

      // Remove cada item que possui o mesmo bundle_group
      bundleItems.forEach(item => {
        console.log('Tentando remover item com key:', item.key); // Log da key do item
        removeItemFromCart(item.key, () => {
          removedItems++;
          // Verifica se todos os itens foram removidos
          if (removedItems === itemsToRemove) {
            console.log('Todos os itens do grupo removidos.');
          }
        });
      });
    })
    .catch(error => console.error('Erro ao remover itens do bundle_group:', error));
}

// Função para remover um item do carrinho com base na sua key
function removeItemFromCart(itemKey, callback) {
  fetch(`/cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: 0 })
  })
    .then(response => response.json())
    .then(() => {
      console.log(`Item removido com sucesso: ${itemKey}`);
      callback();
    })
    .catch(error => console.error(`Erro ao remover item ${itemKey}:`, error));
}



           validateAndRemoveItemsByBundleGroup(); 

            
  // Função para remover todos os itens com o mesmo "bundle_group"
  function removeItemsWithBundleGroup(bundleGroup) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleItems = cart.items.filter(item => item.properties && item.properties.bundle_group === bundleGroup);
        console.log('Itens encontrados com o bundle_group:', bundleItems); // Log dos itens encontrados

        // Variável para rastrear quantos itens precisam ser removidos
        let itemsToRemove = bundleItems.length;
        let removedItems = 0;

        // Remove cada item que possui o mesmo bundle_group
        bundleItems.forEach((item, index) => {
          console.log('Tentando remover item com key:', item.key); // Log da key do item
          removeItemFromCart(item.key, () => {
            removedItems++;
            // Verifica se todos os itens foram removidos
            if (removedItems === itemsToRemove) {
              console.log('Todos os itens do grupo removidos, recarregando a página');
              //setTimeout(() => location.reload(), 1000);

            }
          });
        });
      })
      .catch(error => console.error('Erro ao remover itens do bundle_group:', error));
  }

  // Função para remover um item do carrinho usando a 'key' e chamar o callback após a remoção
  function removeItemFromCart(itemKey, callback) {
    console.log('ID sendo enviado para remoção:', itemKey); // Log do ID/key que está sendo enviado
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
      .then(response => response.json())
      .then(data => {
        console.log('Resposta da remoção do item do carrinho:', data);
        if (callback) callback(); // Chama o callback após a remoção do item
      })
      .catch(error => {
        console.error('Erro ao remover item do carrinho:', error);
      });
  }

  // Função auxiliar para encontrar o valor de bundle_group dentro de um item
  function getBundleGroup(cartItem) {
    const options = cartItem.querySelectorAll('.cart-item__option');
    for (let option of options) {
      const label = option.querySelector('div:first-child');
      const value = option.querySelector('div:last-child');
      if (label && label.textContent.trim() === 'bundle_group:') {
        return value.textContent.trim();
      }
    }
    return null;
  }

  // Adiciona evento de clique nos botões de remoção
  document.addEventListener('click', function (event) {
    if (event.target.closest('.cart-item__remove-button')) {
      const cartItem = event.target.closest('.cart-item');
      const bundleGroup = getBundleGroup(cartItem); // Obtém o bundle_group do item

      console.log('Bundle group detectado no clique:', bundleGroup); // Log do bundle_group detectado

      // Se o item tiver um "bundle_group", remove todos os itens com o mesmo "bundle_group"
      if (bundleGroup) {
        removeItemsWithBundleGroup(bundleGroup);
      }
    }
  });



  // Função para remover todos os itens com o mesmo "bundle_group"
  function removeItemsWithBundleGroup(bundleGroup) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleItems = cart.items.filter(item => item.properties && item.properties.bundle_group === bundleGroup);

        // Log do número total de itens detectados com o bundle_group
        console.log(`Total de itens detectados com o bundle_group '${bundleGroup}': ${bundleItems.length}`);

        // Variável para rastrear quantos itens precisam ser removidos
        let itemsToRemove = bundleItems.length;
        let removedItems = 0;

        // Remove cada item que possui o mesmo bundle_group
        bundleItems.forEach((item) => {
          removeItemFromCart(item.key, () => {
            removedItems++;
            // Log para cada remoção bem-sucedida
            console.log(`Item com key '${item.key}' removido com sucesso (${removedItems}/${itemsToRemove}).`);

            // Verifica se todos os itens foram removidos
            if (removedItems === itemsToRemove) {
              console.log('Todos os itens do grupo removidos, recarregando a página');
              location.reload(); // Recarrega a página após remover o último item
            }
          });
        });
      })
      .catch(error => console.error('Erro ao remover itens do bundle_group:', error));
  }

  // Função para remover um item do carrinho usando a 'key' e chamar o callback após a remoção
  function removeItemFromCart(itemKey, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
      .then(response => response.json())
      .then(data => {
        if (callback) callback(); // Chama o callback após a remoção do item
      })
      .catch(error => {
        console.error('Erro ao remover item do carrinho:', error);
      });
  }

  // Função auxiliar para encontrar o valor de bundle_group dentro de um item
  function getBundleGroup(cartItem) {
    const options = cartItem.querySelectorAll('.cart-item__option');
    for (let option of options) {
      const label = option.querySelector('div:first-child');
      const value = option.querySelector('div:last-child');
      if (label && label.textContent.trim() === 'bundle_group:') {
        return value.textContent.trim();
      }
    }
    return null;
  }

  // Adiciona evento de clique nos botões de remoção
  document.addEventListener('click', function (event) {
    if (event.target.closest('.cart-item__remove-button')) {
      const cartItem = event.target.closest('.cart-item');
      const bundleGroup = getBundleGroup(cartItem); // Obtém o bundle_group do item

      // Se o item tiver um "bundle_group", remove todos os itens com o mesmo "bundle_group"
      if (bundleGroup) {
        removeItemsWithBundleGroup(bundleGroup);
      }
    }
  });




// Função para aplicar classes específicas a propriedades no carrinho
function applyClassToCartProperties() {
  // Seleciona todos os elementos de propriedade no carrinho
  const cartOptions = document.querySelectorAll('.cart-item__option');

  console.log("Iniciando aplicação de classes nas propriedades do carrinho...");

  cartOptions.forEach(option => {
    // Obtém o primeiro e o segundo div dentro de .cart-item__option
    const labelElement = option.querySelector('div:nth-child(1)');
    const valueElement = option.querySelector('div:nth-child(2)');

    // Verifica se ambos os elementos foram encontrados
    if (!labelElement || !valueElement) {
      console.log("Elemento label ou value não encontrado dentro de .cart-item__option");
      return; // Pula para o próximo item se algum deles for null
    }

    const label = labelElement.textContent.trim();

    // Log para verificar o rótulo (label) e o valor encontrado
    console.log("Propriedade encontrada:", label);
    console.log("Valor da propriedade:", valueElement.textContent.trim());

    // Verifica o conteúdo do label e aplica uma classe correspondente ao elemento pai (option)
    if (label.includes('discount_bundle:')) {
      option.classList.add('property-discount-bundle');
      console.log("Classe 'property-discount-bundle' adicionada ao elemento pai:", option);
    } else if (label.includes('bundle_group:')) {
      option.classList.add('property-bundle-group');
      console.log("Classe 'property-bundle-group' adicionada ao elemento pai:", option);
    } else if (label.includes('qtdKit:')) {
      option.classList.add('property-qtd-kit');
      console.log("Classe 'property-qtd-kit' adicionada ao elemento pai:", option);
    } else {
      console.log("Nenhuma classe aplicada para:", label);
    }
  });

  console.log("Aplicação de classes nas propriedades do carrinho concluída.");
}

applyClassToCartProperties();









